import { ALL_AI_VOICES_QUERY } from '@src/gql/ai-voice-gql';
import { LogManager } from '@src/utility/Logger';

import type { AiVoiceRecord } from '@src/types.ts/aiVoiceRecord';
import type { GraphQLClient } from 'graphql-request';

// Resilience contract: if the ai_voice Dato model is absent from the target
// environment (migration not yet applied), GraphQL fails schema validation. We
// catch, log a warn, and return []. Callers treat that as "no voices in the
// catalog". Mirrors TranslationHandlerRepository.
export class AIVoiceRepository {
  private logger = LogManager.getLogger('repository:AIVoiceRepository');
  private cached: AiVoiceRecord[] | null = null;

  constructor(private gqlClient: GraphQLClient) {}

  async getAllActiveVoices(): Promise<AiVoiceRecord[]> {
    if (this.cached) return this.cached;
    try {
      const response = (await this.gqlClient.request(ALL_AI_VOICES_QUERY)) as {
        allAiVoices: AiVoiceRecord[];
      };
      this.cached = response.allAiVoices;
      return this.cached;
    } catch (err) {
      this.logger.warn(
        'Failed to load AI voices; defaulting to empty. This is expected if the ai_voice Dato model has not been migrated yet.',
        err,
      );
      return [];
    }
  }
}
